import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=74cfb2fc&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74cfb2fc')) {
      api.createRecord('74cfb2fc', component.options)
    } else {
      api.reload('74cfb2fc', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=74cfb2fc&", function () {
      api.rerender('74cfb2fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/setting/sector-line/edit.vue"
export default component.exports